import apiClient from './apiClient';

export interface SpecialtyResponse {
    id: string;
    name: string;
    description?: string;
    isActive: boolean;
}

export interface SpecialtyCreateRequest {
    salonId: string;
    name: string;
    description?: string;
}

export interface SpecialtyUpdateRequest {
    name?: string;
    description?: string;
    active?: boolean;
}

export const specialtyApi = {
    /**
     * Get all active specialties for a salon
     */
    getSalonSpecialties: async (salonId: string): Promise<SpecialtyResponse[]> => {
        const response = await apiClient.get<SpecialtyResponse[]>(`/specialties/salon/${salonId}`);
        return response.data;
    },

    /**
     * Create a new specialty
     */
    createSpecialty: async (request: SpecialtyCreateRequest): Promise<SpecialtyResponse> => {
        const response = await apiClient.post<SpecialtyResponse>('/specialties', request);
        return response.data;
    },

    /**
     * Update a specialty
     */
    updateSpecialty: async (id: string, request: SpecialtyUpdateRequest): Promise<SpecialtyResponse> => {
        const response = await apiClient.put<SpecialtyResponse>(`/specialties/${id}`, request);
        return response.data;
    },

    /**
     * Delete a specialty
     */
    deleteSpecialty: async (id: string): Promise<void> => {
        await apiClient.delete(`/specialties/${id}`);
    }
};

export default specialtyApi;
